import { fg } from '@atlassian/jira-feature-gating';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { toEventId } from '@atlassian/jira-forge-ui-types/src/common/types/analytics.tsx';
import type { FetchForgeContextTokenFunction } from '../../types.tsx';
import { trackPromiseExecution } from './analytics.tsx';

export const fetchForgeCommonContextToken: FetchForgeContextTokenFunction = async ({
	extension,
	extensionData,
	localId,
}) => {
	const tokenResult = performPostRequest('/rest/internal/2/forge/context/token', {
		body: JSON.stringify({
			extension,
			extensionData,
			localId,
			useWorkspaceAri: true,
		}),
	});

	if (fg('ditto-track-forge-context-token-fetch')) {
		const EVENT_ID = toEventId('fetchForgeCommonContextToken');
		return trackPromiseExecution(tokenResult, EVENT_ID);
	}

	return tokenResult;
};
